module.exports = __webpack_public_path__ + "img/chevron-left-sharp-light.3b497dea.svg";